/**
 * Environment-aware logger.
 *
 * - In development (`NODE_ENV !== 'production'`), forwards to `console.*`.
 * - In production builds, warn/error still flow through to the browser console
 *   (they're operationally useful), but `debug`/`info` are silenced so we don't
 *   ship chatty logs to end users.
 *
 * Swap the production sinks with Sentry / Datadog / LogRocket etc. when you
 * wire up an error tracking service.
 */
const isProd = process.env.NODE_ENV === "production";

const noop = () => {};

export const logger = {
  debug: isProd ? noop : (...args) => console.debug(...args),
  info: isProd ? noop : (...args) => console.info(...args),
  warn: (...args) => console.warn(...args),
  error: (...args) => console.error(...args),
};

export default logger;
